module.exports = __webpack_public_path__ + "static/media/emissor-r-8.2a3eebe1.png";